var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',[_c('template',{slot:"header"},[_c('p',{staticClass:"card-header-title"},[_vm._v("Invoices")])]),_c('template',{slot:"body"},[_c('invoices-table',{attrs:{"user-id":_vm.userId}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }